import * as React from 'react';
import { FilialNavItemProps } from '../../Navigator.type';
import { NavigatorService } from '../../Navigator.service';
import { NavigatorMap } from '../../Navigator.map';

export function FilialNavItem({
  account,
  activeItem,
  pathName,
  onOpenSubmenu
}: FilialNavItemProps) {
  const hasMultipleFilials = NavigatorService.shouldRenderFilialsSubmenu(account);
  const isActive = activeItem === 'filials';
  const filialsIcon = NavigatorService.getFeatureIcon('filials');
  const schema = NavigatorMap.getFeatureSchema().filials;

  if (hasMultipleFilials) {
    return (
      <li className={`nav-item ${isActive ? 'ativo' : ''} ${schema?.items?.length > 0 ? 'submenu' : ''}`}>
        <a 
          href={schema?.items?.length > 0 ? "#" : NavigatorMap.buildFeatureUrl(account, 'filials')}
          onClick={(event) => {
            if (schema?.items?.length > 0) {
              onOpenSubmenu(event, 'filials');
            }
          }}
        >
          <i className={`fa-light fa-${filialsIcon}`}></i>
          <span>{NavigatorService.getFeatureLabel('filials')}</span>
        </a>
        
        {schema?.items?.length > 0 && (
          <ul className="submenu">
            {schema.items.map((item, index) => (
              <li 
                key={index} 
                className={NavigatorMap.isItemActive(pathName, account, item.url) ? 'ativo' : ''}
              >
                <a href={NavigatorMap.buildItemUrl(account, item.url)}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  }

  // Caso de filial única
  const editUrl = NavigatorService.getFilialsEditUrl(account);
  const isEditActive = pathName === editUrl;

  return (
    <li className={`nav-item ${isActive ? 'ativo' : ''}`}>
      <a href={editUrl}>
        <i className={`fa-light fa-${filialsIcon}`}></i>
        <span>Local de Atuação</span>
      </a>
      
      <ul className="submenu">
        <li className={isEditActive ? 'ativo' : ''}>
          <a href={editUrl}>
            Editar Endereço
          </a>
        </li>
      </ul>
    </li>
  );
}
